import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NbInputModule } from '@nebular/theme';
import { TyaDirectivesModule } from '../../directives/tya-directives.module';
import { TyaNumberVnInputComponent } from './tya-number-vn-input.component';

@NgModule({
  declarations: [
    TyaNumberVnInputComponent,
  ],
  imports: [
    TyaDirectivesModule,
    CommonModule,
    FormsModule,
    NbInputModule,
  ],
  exports: [
    TyaNumberVnInputComponent
  ]
})
export class TyaNumberVnInputModule { }
